export default __webpack_public_path__ + "static/img/repli.b66d10d.png";